import isPhoneNumberValid from './isPhoneNumberValid';

// Проверить, является ли номер кошелька самозанятых валидным
// number: string
export default function isSzWalletNumberValid(number) {
  return isPhoneNumberValid(number);
}
